import { Container, Typography } from "@material-ui/core"
import dynamic from "next/dynamic"
import styled from "styled-components"
import colors from "theme/colors"
import loader from "../../public/animation/loadingAi.json"

const Lottie = dynamic(() => import("lottie-react"), { ssr: false })

const StyledLoadingContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 200px;
  position: relative;
  padding-bottom: 140px;
`
const StyledTitle = styled(Typography).attrs({
  component: "h1",
  variant: "h1",
})`
  color: ${colors.black};
  white-space: nowrap;
  font-size: 40px;
  line-height: 0.6;
  font-family: Speedee, NarkisBlock, sans-serif;
  height: 40px;
  margin-bottom: 20px;

  ${(p) => p.theme.breakpoints.up("md")} {
    margin-bottom: 8px;
  }
`
const StyledExplanation = styled(Typography).attrs({
  variant: "body1",
})`
  font-size: 24px;
  font-weight: 100;
  line-height: 1.2;
  text-align: right;
  margin-bottom: 40px;
  text-align: center;

  ${(p) => p.theme.breakpoints.down("sm")} {
    font-size: 20px;
    padding: 0 30px;
  }
  ${(p) => p.theme.breakpoints.up("md")} {
    width: 380px;
  }
`
const StyledLottie = styled(Lottie)`
  width: 100px;

  ${(p) => p.theme.breakpoints.up("md")} {
    width: 100px;
    margin-bottom: 30px;
  }
`

const LoadingAiPage = () => {
  return (
    <StyledLoadingContainer>
      <StyledLottie animationData={loader} loop={true} />

      <StyledTitle>רק רגע... מכינים את התמונה</StyledTitle>
      <StyledExplanation>
        לא קל להמיר את התמונות האלה שחשבת עליהן! <br />
        כמה שניות והיצירה שלך מוכנה
      </StyledExplanation>
    </StyledLoadingContainer>
  )
}

export default LoadingAiPage
